import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-results-found',
  templateUrl: './no-results-found.component.html',
  styleUrls: ['./no-results-found.component.scss']
})
export class NoResultsFoundComponent implements OnInit {

  @Input('message') message: string = 'No Applications Found!';
  @Input('icon') icon: string = 'assets/icons/quicklook-ico.svg';
  @Input('image') image: string = 'assets/images/banner/job-posting-student.svg';
  @Input('wrapperClass') wrapperClass: string = 'noJobIco mt-4 text-center';
  @Input('wrapperClassList') wrapperClassList: string[] = [''];
  @Input('iconClass') iconClass: string = 'd-inline-block';
  @Input('iconClassList') iconClassList: string[] = [''];
  @Input('messageClass') messageClass: string = 'primary-text avenirBlack fw-light font-size-20 mb-4 mt-3';
  @Input('messageClassList') messageClassList: string[] = [''];
  @Input('imageClass') imageClass: string = 'd-inline-block no-job-icon-width';
  @Input('imageClassList') imageClassList: string[] = [''];
  @Input('disableIcon') disableIcon: boolean = false;
  @Input('disableImage') disableImage: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
